import VueLoader from '../vue-loader'
import CustomerServiceForm from './form'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(CustomerServiceForm, document.getElementById('customerServiceForm'))
})
